// MeuFrete, o portal da transportadora (épico PO1-2285). Todas as rotas
// /meufrete/* são do backend_hub (instância `api`); a transportadora vem do
// token, nunca do cliente.
import api from "./api";

// ─── Minhas faturas (PO1-3160) ───────────────────────────────────────────────
export async function listarFaturas(params = {}) {
  const { data } = await api.get("/meufrete/faturas", { params });
  return data;
}

export async function resumoFaturas(params = {}) {
  const { data } = await api.get("/meufrete/faturas/resumo", { params });
  return data;
}

// ─── Fatura reprovada: contestar / cancelar (PO1-3222) ───────────────────────
// CT-e marcados Não OK na fatura (os "CT-e em questão" da devolução).
export async function ctesReprovados(idFatura) {
  const { data } = await api.get(`/meufrete/faturas/${idFatura}/ctes-reprovados`);
  return Array.isArray(data) ? data : [];
}

// Contestação: texto obrigatório + anexos opcionais, sempre multipart.
export async function contestarFatura(idFatura, { texto, arquivos } = {}) {
  const form = new FormData();
  form.append("texto", String(texto || "").trim());
  (arquivos || []).forEach((f) => form.append("anexos", f, f.name));
  const { data } = await api.post(`/meufrete/faturas/${idFatura}/contestar`, form, {
    headers: { "content-type": "multipart/form-data" },
  });
  return data;
}

export async function cancelarFatura(idFatura, { motivo } = {}) {
  const corpo = {};
  if (motivo && String(motivo).trim()) corpo.motivo = String(motivo).trim();
  const { data } = await api.post(`/meufrete/faturas/${idFatura}/cancelar`, corpo);
  return data;
}

// ─── Cadastro (PO1-2308) ─────────────────────────────────────────────────────
export async function getCadastro() {
  const { data } = await api.get("/meufrete/cadastro");
  return data;
}

export async function atualizarEstabelecimento(id, dados) {
  const { data } = await api.put(`/meufrete/cadastro/estabelecimentos/${id}`, dados);
  return data;
}

export async function atualizarPelaReceita(id) {
  const { data } = await api.post(`/meufrete/cadastro/estabelecimentos/${id}/receita`);
  return data;
}

export async function listarTiposContato() {
  const { data } = await api.get("/meufrete/tipos-contato");
  return data;
}

export async function listarContatos(embarcadorId) {
  const { data } = await api.get("/meufrete/contatos", { params: { embarcadorId } });
  return data;
}

export async function sugestoesContatos(embarcadorId) {
  const { data } = await api.get("/meufrete/contatos/sugestoes", { params: { embarcadorId } });
  return data;
}

export async function criarContato(dados) {
  const { data } = await api.post("/meufrete/contatos", dados);
  return data;
}

export async function atualizarContato(id, dados) {
  const { data } = await api.put(`/meufrete/contatos/${id}`, dados);
  return data;
}

// Cadastro pela Everlog (admin): mesmos campos, origem EVERLOG, mais o histórico.
export async function adminGetCadastro(idTransportadora) {
  const { data } = await api.get(`/transportadoras/${idTransportadora}/cadastro`);
  return data;
}

export async function adminAtualizarCadastro(idTransportadora, dados) {
  const { data } = await api.put(`/transportadoras/${idTransportadora}/cadastro`, dados);
  return data;
}

export async function adminAtualizarPelaReceita(idTransportadora) {
  const { data } = await api.post(`/transportadoras/${idTransportadora}/cadastro/receita`);
  return data;
}

export async function adminHistoricoCadastro(idTransportadora) {
  const { data } = await api.get(`/transportadoras/${idTransportadora}/historico`);
  return data;
}

// ─── Aba Contatos do cadastro, admin (PO1-3492) ──────────────────────────────
// { tipos, carteira, contatos: [{ chave, id, idTipoContato, tipoContato, nome, email, ..., embarcadores: [{ idContato, idEmbarcador, nome }] }] }
export async function adminListarContatos(idTransportadora) {
  const { data } = await api.get(`/transportadoras/${idTransportadora}/contatos`);
  return data;
}

// Cria nos embarcadores escolhidos (da carteira); quem já tem o mesmo e-mail e tipo fica como está.
export async function adminCriarContato(idTransportadora, { dados, embarcadores }) {
  const { data } = await api.post(`/transportadoras/${idTransportadora}/contatos`, { dados, embarcadores });
  return data;
}

// Edita a pessoa (vale para todos os embarcadores com o mesmo e-mail).
export async function adminAtualizarContato(idTransportadora, idContato, dados) {
  const { data } = await api.put(`/transportadoras/${idTransportadora}/contatos/${idContato}`, dados);
  return data;
}

// ─── Tabelas de preço enviadas (PO1-2312) ────────────────────────────────────
export async function enviarTabela(formData) {
  const { data } = await api.post("/meufrete/tabelas", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return data;
}

export async function listarTabelasEnviadas(params = {}) {
  const { data } = await api.get("/meufrete/tabelas", { params });
  return data;
}

export async function urlArquivoTabela(idItem, idArquivo) {
  const { data } = await api.get(`/meufrete/tabelas/${idItem}/arquivos/${idArquivo}/url`);
  return data;
}

// ─── Rede Everlog (épico PO1-3359: H3 PO1-3648 cobertura, H4 PO1-3650 tabelas e API) ──
// Só para transportadora com vínculo com a Rede (404 sem vínculo). Contrato:
// contratos-rede-everlog.md, seção 4.

// { ativa, temRede, soRede }: mostra as 3 abas do Cadastro e o boas-vindas.
export async function redeStatus() {
  const { data } = await api.get("/meufrete/rede/status");
  return data;
}

export async function redeEstados() {
  const { data } = await api.get("/meufrete/rede/estados");
  return (data && data.items) || [];
}

export async function redeCidades(uf, q) {
  const { data } = await api.get("/meufrete/rede/cidades", { params: { uf, q: q || undefined } });
  return (data && data.items) || [];
}

// { items: [{ id, origem: { idCidade, cidade, idEstado, uf }, destino: {...} }] }
export async function redeCobertura() {
  const { data } = await api.get("/meufrete/rede/cobertura");
  return (data && data.items) || [];
}

// Substitui a lista (1 a 200 rotas no formato { origem: {idCidade}|{idEstado}, destino }).
export async function salvarRedeCobertura(rotas) {
  const { data } = await api.put("/meufrete/rede/cobertura", { rotas });
  return (data && data.items) || [];
}

export async function listarTabelasReferencia() {
  const { data } = await api.get("/meufrete/rede/tabelas-referencia");
  return (data && data.items) || [];
}

// multipart: arquivos em `arquivos` (1 a 5), visivelEmbarcadores, vigência e observação.
export async function enviarTabelasReferencia(arquivos, { visivelEmbarcadores, vigenciaInicio, vigenciaFim, observacao } = {}) {
  const form = new FormData();
  (arquivos || []).forEach((f) => form.append("arquivos", f, f.name));
  form.append("visivelEmbarcadores", visivelEmbarcadores ? "true" : "false");
  if (vigenciaInicio) form.append("vigenciaInicio", vigenciaInicio);
  if (vigenciaFim) form.append("vigenciaFim", vigenciaFim);
  if (observacao && String(observacao).trim()) form.append("observacao", String(observacao).trim());
  const { data } = await api.post("/meufrete/rede/tabelas-referencia", form, {
    headers: { "content-type": "multipart/form-data" },
  });
  return (data && data.items) || [];
}

export async function atualizarTabelaReferencia(id, dados) {
  const { data } = await api.patch(`/meufrete/rede/tabelas-referencia/${id}`, dados);
  return data && data.item;
}

export async function removerTabelaReferencia(id) {
  const { data } = await api.delete(`/meufrete/rede/tabelas-referencia/${id}`);
  return data;
}

// { url } pré-assinada (15 min).
export async function urlTabelaReferencia(id) {
  const { data } = await api.get(`/meufrete/rede/tabelas-referencia/${id}/download`);
  return data;
}

// { api: { temApi, tipo, docUrl, contatoNome, contatoEmail, observacao } }
export async function redeApiCotacao() {
  const { data } = await api.get("/meufrete/rede/api-cotacao");
  return (data && data.api) || null;
}

export async function salvarRedeApiCotacao(apiCotacao) {
  const { data } = await api.put("/meufrete/rede/api-cotacao", apiCotacao);
  return (data && data.api) || null;
}

// ─── Acesso SFTP por embarcador (PO1-2309, épico PO1-3279) ───────────────────
// A transportadora vê o acesso de cada embarcador atendido e gerencia o segredo.
// Nunca cria acesso: quem cria é o Onboarding de Transportadora da Everlog.
export async function listarAcessoSftp() {
  const { data } = await api.get("/meufrete/acesso-sftp");
  return data;
}

// { senha }, no-store; cada exibição fica registrada no backend.
export async function mostrarSenhaAcessoSftp(idEmbarcador) {
  const { data } = await api.get(`/meufrete/acesso-sftp/${idEmbarcador}/senha`);
  return data;
}

// Gera senha nova (também adota o acesso legado). Confirmação obrigatória.
export async function gerarNovaSenhaAcessoSftp(idEmbarcador, { email } = {}) {
  const { data } = await api.post(`/meufrete/acesso-sftp/${idEmbarcador}/senha`, {
    email: email || undefined,
    confirmacao: true,
  });
  return data;
}

export async function incluirChaveAcessoSftp(idEmbarcador, { nome, chavePublica }) {
  const { data } = await api.post(`/meufrete/acesso-sftp/${idEmbarcador}/chaves`, { nome, chavePublica });
  return data;
}

export async function removerChaveAcessoSftp(idEmbarcador, idChave) {
  const { data } = await api.delete(`/meufrete/acesso-sftp/${idEmbarcador}/chaves/${idChave}`);
  return data;
}

// Adapta as rotas do MeuFrete à interface `api` dos componentes compartilhados
// em components/AcessoSftp (que a tela admin usa com as rotas /sftp-acesso/...).
// Os componentes recebem (idEmbarcador, idTransportadora): aqui a transportadora
// vem do token, então o segundo argumento é ignorado.
export const acessoSftpMeuFreteApi = {
  mostrarSenha: (idEmbarcador) => mostrarSenhaAcessoSftp(idEmbarcador),
  gerarNovaSenha: (idEmbarcador, _idTransportadora, opts) => gerarNovaSenhaAcessoSftp(idEmbarcador, opts),
  incluirChave: (idEmbarcador, _idTransportadora, chave) => incluirChaveAcessoSftp(idEmbarcador, chave),
  removerChave: (idEmbarcador, _idTransportadora, idChave) => removerChaveAcessoSftp(idEmbarcador, idChave),
  mensagemErro: (err, fallback) => mensagemErro(err, fallback),
};

// ─── Extrato e pedido de análise (PO1-3390) ──────────────────────────────────
// `campoData`: emissao (padrão) | entrega; `divergencia`: 1 liga a regra da
// Auditoria. Datas como "YYYY-MM-DD HH:mm:ss".
export async function listarExtrato(params = {}) {
  const { data } = await api.get("transportadora/extrato/listar-extrato", { params });
  return Array.isArray(data) ? data : [];
}

export async function listarCtesDoDia(params = {}) {
  const { data } = await api.get("transportadora/extrato/listar-ctes", { params });
  return Array.isArray(data) ? data : [];
}

// CT-es de um pedido de análise (link `?pedido=<token>` do e-mail da H1). É a
// única chamada do Extrato que traz o valor pela tabela e a diferença (P7).
export async function ctesDoPedido(token) {
  const { data } = await api.get("transportadora/extrato/pedido", { params: { token } });
  return data;
}

// Mensagem de erro no padrão do backend ({ error } ou { message }).
export function mensagemErro(err, fallback) {
  const d = (err && err.response && err.response.data) || {};
  if (d.error && typeof d.error === "object") {
    return Object.values(d.error).join("; ");
  }
  if (d.errors && typeof d.errors === "object") {
    return Object.values(d.errors).join("; ");
  }
  return d.error || d.message || (err && err.message) || fallback || "Erro inesperado";
}

// ─── BID de Frete (épico PO1-2413, H6/H7) ────────────────────────────────────
// A transportadora responde o BID SÓ pelo MeuFrete (revisão 5); vê apenas os
// BIDs em que é participante (transportadora do login). Contrato ASSUMIDO
// (backend da 2ª metade em construção, paths da spec seção F):
// - GET /meufrete/bid-frete -> { items:[{ id, nome, embarcadorNome, ufs, regioes, prazoPropostas,
//   estado (do participante), propostaEm, pacoteEm, situacao }] }
// - GET /meufrete/bid-frete/:id -> o item + { areas, dataEmissaoDe, dataEmissaoAte, tpl*, idFreteTabelaProposta,
//   podeEnviar, serverNow } (o primeiro acesso marca VISUALIZOU)
// - GET /meufrete/bid-frete/:id/pacote/:arquivo -> { url, expiraEm } (15 min)
// - POST /meufrete/bid-frete/:id/proposta multipart `arquivo` (.xlsx/.xlsm da planilha modelo)
//   -> { idFreteTabela, linhasCusto, linhasTaxa, propostaEm }; 400 `planilha_invalida` { erros:[{ aba, linha, coluna, mensagem }] }
// - POST /meufrete/bid-frete/:id/recusar { motivo? }
export async function listarBidsFrete(params = {}) {
  const { data } = await api.get("/meufrete/bid-frete", { params });
  return data;
}

export async function obterBidFrete(id) {
  const { data } = await api.get(`/meufrete/bid-frete/${id}`);
  return data;
}

export async function urlPacoteBidFrete(id, arquivo) {
  const { data } = await api.get(`/meufrete/bid-frete/${id}/pacote/${arquivo}`);
  return data;
}

export async function enviarPropostaBidFrete(id, arquivo) {
  const form = new FormData();
  form.append("arquivo", arquivo);
  const { data } = await api.post(`/meufrete/bid-frete/${id}/proposta`, form, {
    headers: { "content-type": "multipart/form-data" },
  });
  return data;
}

export async function recusarBidFrete(id, { motivo } = {}) {
  const { data } = await api.post(`/meufrete/bid-frete/${id}/recusar`, motivo ? { motivo } : {});
  return data;
}
